<template>
  <div class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1">
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="w-48 px-4 text-sm">
            {{ issueDate }}
          </div>
          <div class="flex-1 px-4 text-sm">
            {{ invoice.issuerName }}
          </div>
          <div class="w-32 px-4 text-sm">
            {{ invoice.number }}
          </div>
          <div class="w-32 px-4 text-sm text-right">{{ invoice.amount }} &euro;</div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <button
          :disabled="!invoice.can.view || disabled"
          class="w-10 h-10 px-4 py-2 rounded text-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-600 disabled:bg-transparent"
          @click="$emit('invoice:view', invoice)"
        >
          <FontAwesomeIcon icon="chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    invoice: { type: Object, required: true },
    disabled: Boolean,
  },

  computed: {
    issueDate() {
      return moment(this.invoice.issueDate).format('DD/MM/YYYY');
    },
  },
};
</script>
